// extracted by mini-css-extract-plugin
export default {"modalContent":"styles_modalContent__-0x7l","tightBreak":"styles_tightBreak__mAvSI","fullView":"styles_fullView__0F6gq","shimmer":"styles_shimmer__+-O30"};